angular.module('app').directive('adminAutocomplete', function() {
    return {
        restrict: 'A',
        priority: -1,
        compile: function(element, attrs) {
            var menuClass = attrs.mdMenuClass || '';
            var icon = element[0].querySelector('md-autocomplete-wrap button md-icon');

            attrs.$set('mdMenuClass', (menuClass + ' admin-autocomplete-menu').trim());

            if (attrs.ariaLabel) {
                element.find('input').attr('aria-label', attrs.ariaLabel);
            }

            if (!icon) {
                return;
            }

            angular.element(icon)
                .removeAttr('md-svg-src')
                .attr('md-svg-icon', 'input-clear');
        }
    };
});
